// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".videoTipsTable,.videoTipsTable td,.videoTipsTable th{border:1px solid;border-collapse:collapse;margin:5px;padding:5px}.opicon{font-size:4rem!important;margin-left:-18px;padding-top:0}.google-map{height:100%;width:100%}.vBtn{background-color:#cff1ff;border:0;color:#1976d2;cursor:pointer;padding:2px 8px}.play-icon{height:16px;vertical-align:middle}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
